module.exports = __webpack_public_path__ + "img/map.2d5c434d.svg";